export type PrefectureBoundsLiteral = google.maps.LatLngBoundsLiteral;

interface PrefectureBoundsEntry {
  aliases: string[];
  bounds: PrefectureBoundsLiteral;
}

const ENTRIES: PrefectureBoundsEntry[] = [
  {
    aliases: ["Hokkaido", "Hokkaidō", "北海道", "Hokkaido Prefecture", "JP-01", "Hokkaido-ken"],
    bounds: { south: 41.2, west: 139.0, north: 45.7, east: 145.8 }
  },
  {
    aliases: ["Aomori", "青森県", "Aomori Prefecture", "JP-02", "Aomori-ken"],
    bounds: { south: 40.2, west: 139.4, north: 41.6, east: 141.5 }
  },
  {
    aliases: ["Iwate", "岩手県", "Iwate Prefecture", "JP-03", "Iwate-ken"],
    bounds: { south: 38.7, west: 140.6, north: 40.4, east: 142.1 }
  },
  {
    aliases: ["Miyagi", "宮城県", "Miyagi Prefecture", "JP-04", "Miyagi-ken"],
    bounds: { south: 37.7, west: 140.4, north: 39.2, east: 141.5 }
  },
  {
    aliases: ["Akita", "秋田県", "Akita Prefecture", "JP-05", "Akita-ken"],
    bounds: { south: 38.9, west: 139.2, north: 40.3, east: 140.9 }
  },
  {
    aliases: ["Yamagata", "山形県", "Yamagata Prefecture", "JP-06", "Yamagata-ken"],
    bounds: { south: 37.5, west: 139.3, north: 39.1, east: 140.5 }
  },
  {
    aliases: ["Fukushima", "福島県", "Fukushima Prefecture", "JP-07", "Fukushima-ken"],
    bounds: { south: 36.6, west: 139.2, north: 37.9, east: 141.1 }
  },
  {
    aliases: ["Ibaraki", "茨城県", "Ibaraki Prefecture", "JP-08", "Ibaraki-ken"],
    bounds: { south: 35.7, west: 139.7, north: 36.9, east: 141.0 }
  },
  {
    aliases: ["Tochigi", "栃木県", "Tochigi Prefecture", "JP-09", "Tochigi-ken"],
    bounds: { south: 36.1, west: 139.3, north: 37.1, east: 139.9 }
  },
  {
    aliases: ["Gunma", "群馬県", "Gunma Prefecture", "JP-10", "Gunma-ken"],
    bounds: { south: 36.0, west: 138.6, north: 37.1, east: 139.7 }
  },
  {
    aliases: ["Saitama", "埼玉県", "Saitama Prefecture", "JP-11", "Saitama-ken"],
    bounds: { south: 35.7, west: 138.9, north: 36.3, east: 139.9 }
  },
  {
    aliases: ["Chiba", "千葉県", "Chiba Prefecture", "JP-12", "Chiba-ken"],
    bounds: { south: 34.7, west: 139.7, north: 35.9, east: 140.9 }
  },
  {
    aliases: ["Tokyo", "東京都", "Tokyo Prefecture", "Tokyo Metropolis", "JP-13", "Tokyo-to"],
    bounds: { south: 35.3, west: 139.2, north: 35.9, east: 139.9 }
  },
  {
    aliases: ["Kanagawa", "神奈川県", "Kanagawa Prefecture", "JP-14", "Kanagawa-ken"],
    bounds: { south: 35.1, west: 139.0, north: 35.6, east: 139.8 }
  },
  {
    aliases: ["Niigata", "新潟県", "Niigata Prefecture", "JP-15", "Niigata-ken"],
    bounds: { south: 36.7, west: 137.5, north: 38.6, east: 139.8 }
  },
  {
    aliases: ["Toyama", "富山県", "Toyama Prefecture", "JP-16", "Toyama-ken"],
    bounds: { south: 36.3, west: 136.8, north: 36.9, east: 137.7 }
  },
  {
    aliases: ["Ishikawa", "石川県", "Ishikawa Prefecture", "JP-17", "Ishikawa-ken"],
    bounds: { south: 36.0, west: 136.1, north: 37.6, east: 137.5 }
  },
  {
    aliases: ["Fukui", "福井県", "Fukui Prefecture", "JP-18", "Fukui-ken"],
    bounds: { south: 35.3, west: 135.2, north: 36.4, east: 136.6 }
  },
  {
    aliases: ["Yamanashi", "山梨県", "Yamanashi Prefecture", "JP-19", "Yamanashi-ken"],
    bounds: { south: 35.2, west: 138.2, north: 35.9, east: 139.0 }
  },
  {
    aliases: ["Nagano", "長野県", "Nagano Prefecture", "JP-20", "Nagano-ken"],
    bounds: { south: 35.0, west: 137.3, north: 36.9, east: 138.8 }
  },
  {
    aliases: ["Gifu", "岐阜県", "Gifu Prefecture", "JP-21", "Gifu-ken"],
    bounds: { south: 35.1, west: 136.3, north: 36.5, east: 137.9 }
  },
  {
    aliases: ["Shizuoka", "静岡県", "Shizuoka Prefecture", "JP-22", "Shizuoka-ken"],
    bounds: { south: 34.4, west: 137.4, north: 35.7, east: 139.2 }
  },
  {
    aliases: ["Aichi", "愛知県", "Aichi Prefecture", "JP-23", "Aichi-ken"],
    bounds: { south: 34.5, west: 136.6, north: 35.4, east: 137.9 }
  },
  {
    aliases: ["Mie", "三重県", "Mie Prefecture", "JP-24", "Mie-ken"],
    bounds: { south: 33.6, west: 135.3, north: 35.0, east: 137.3 }
  },
  {
    aliases: ["Shiga", "滋賀県", "Shiga Prefecture", "JP-25", "Shiga-ken"],
    bounds: { south: 34.8, west: 135.6, north: 35.7, east: 136.4 }
  },
  {
    aliases: ["Kyoto", "京都府", "Kyoto Prefecture", "JP-26", "Kyoto-fu"],
    bounds: { south: 34.6, west: 134.9, north: 35.8, east: 136.1 }
  },
  {
    aliases: ["Osaka", "大阪府", "Osaka Prefecture", "JP-27", "Osaka-fu"],
    bounds: { south: 34.2, west: 135.1, north: 34.9, east: 135.7 }
  },
  {
    aliases: ["Hyogo", "兵庫県", "Hyogo Prefecture", "JP-28", "Hyogo-ken"],
    bounds: { south: 34.2, west: 134.1, north: 35.7, east: 135.6 }
  },
  {
    aliases: ["Nara", "奈良県", "Nara Prefecture", "JP-29", "Nara-ken"],
    bounds: { south: 34.1, west: 135.5, north: 35.0, east: 136.2 }
  },
  {
    aliases: ["Wakayama", "和歌山県", "Wakayama Prefecture", "JP-30", "Wakayama-ken"],
    bounds: { south: 33.2, west: 134.9, north: 34.4, east: 135.9 }
  },
  {
    aliases: ["Tottori", "鳥取県", "Tottori Prefecture", "JP-31", "Tottori-ken"],
    bounds: { south: 35.0, west: 133.0, north: 35.7, east: 134.4 }
  },
  {
    aliases: ["Shimane", "島根県", "Shimane Prefecture", "JP-32", "Shimane-ken"],
    bounds: { south: 34.3, west: 131.4, north: 35.5, east: 133.4 }
  },
  {
    aliases: ["Okayama", "岡山県", "Okayama Prefecture", "JP-33", "Okayama-ken"],
    bounds: { south: 34.2, west: 133.2, north: 35.1, east: 134.4 }
  },
  {
    aliases: ["Hiroshima", "広島県", "Hiroshima Prefecture", "JP-34", "Hiroshima-ken"],
    bounds: { south: 33.9, west: 132.0, north: 34.9, east: 133.5 }
  },
  {
    aliases: ["Yamaguchi", "山口県", "Yamaguchi Prefecture", "JP-35", "Yamaguchi-ken"],
    bounds: { south: 33.7, west: 130.6, north: 34.6, east: 132.4 }
  },
  {
    aliases: ["Tokushima", "徳島県", "Tokushima Prefecture", "JP-36", "Tokushima-ken"],
    bounds: { south: 33.6, west: 133.6, north: 34.2, east: 134.9 }
  },
  {
    aliases: ["Kagawa", "香川県", "Kagawa Prefecture", "JP-37", "Kagawa-ken"],
    bounds: { south: 34.0, west: 133.5, north: 34.4, east: 134.4 }
  },
  {
    aliases: ["Ehime", "愛媛県", "Ehime Prefecture", "JP-38", "Ehime-ken"],
    bounds: { south: 32.9, west: 132.0, north: 34.1, east: 133.8 }
  },
  {
    aliases: ["Kochi", "高知県", "Kochi Prefecture", "JP-39", "Kochi-ken"],
    bounds: { south: 32.5, west: 132.3, north: 33.9, east: 134.3 }
  },
  {
    aliases: ["Fukuoka", "福岡県", "Fukuoka Prefecture", "JP-40", "Fukuoka-ken"],
    bounds: { south: 33.0, west: 129.4, north: 33.9, east: 131.0 }
  },
  {
    aliases: ["Saga", "佐賀県", "Saga Prefecture", "JP-41", "Saga-ken"],
    bounds: { south: 32.9, west: 129.7, north: 33.6, east: 130.5 }
  },
  {
    aliases: ["Nagasaki", "長崎県", "Nagasaki Prefecture", "JP-42", "Nagasaki-ken"],
    bounds: { south: 32.4, west: 128.0, north: 34.2, east: 130.5 }
  },
  {
    aliases: ["Kumamoto", "熊本県", "Kumamoto Prefecture", "JP-43", "Kumamoto-ken"],
    bounds: { south: 31.9, west: 129.6, north: 33.1, east: 131.6 }
  },
  {
    aliases: ["Oita", "大分県", "Oita Prefecture", "Ōita", "JP-44", "Oita-ken"],
    bounds: { south: 32.7, west: 130.7, north: 33.7, east: 132.1 }
  },
  {
    aliases: ["Miyazaki", "宮崎県", "Miyazaki Prefecture", "JP-45", "Miyazaki-ken"],
    bounds: { south: 31.2, west: 130.5, north: 32.9, east: 131.9 }
  },
  {
    aliases: ["Kagoshima", "鹿児島県", "Kagoshima Prefecture", "JP-46", "Kagoshima-ken"],
    bounds: { south: 27.0, west: 128.5, north: 32.5, east: 131.5 }
  },
  {
    aliases: ["Okinawa", "沖縄県", "Okinawa Prefecture", "JP-47", "Okinawa-ken"],
    bounds: { south: 24.0, west: 122.9, north: 27.0, east: 131.0 }
  }
];

const normalize = (value: string) =>
  value.trim().toLowerCase().replace(/\s+/g, "").replace(/[-_]/g, "");

const BOUNDS_BY_ALIAS = new Map<string, PrefectureBoundsLiteral>();

ENTRIES.forEach(({ aliases, bounds }) => {
  aliases.forEach((alias) => {
    BOUNDS_BY_ALIAS.set(normalize(alias), bounds);
  });
});

export const getPrefectureBounds = (region?: string): PrefectureBoundsLiteral | null => {
  if (!region) {
    return null;
  }

  const normalized = normalize(region);

  return BOUNDS_BY_ALIAS.get(normalized) || null;
};
